
export { PageName } from "./src/interfaces/event"